import { createEffect, createSignal } from "solid-js";
import type { useLocation } from "@tanstack/solid-router";
import type { ListGroup, ListWithMeta } from "@listto/shared";

export function useAppDialogs(location: ReturnType<typeof useLocation>) {
  const [listDialogOpen, setListDialogOpen] = createSignal(false);
  const [creationGroupId, setCreationGroupId] = createSignal<string | undefined>(undefined);
  const [shareDialogOpen, setShareDialogOpen] = createSignal(false);
  const [selectedList, setSelectedList] = createSignal<ListWithMeta | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = createSignal(false);
  const [choiceDialogOpen, setChoiceDialogOpen] = createSignal(false);
  const [groupDialogOpen, setGroupDialogOpen] = createSignal(false);
  const [editingGroup, setEditingGroup] = createSignal<ListGroup | null>(null);
  const [shortcutsOpen, setShortcutsOpen] = createSignal(false);

  createEffect(() => {
    void location().pathname;
    setIsSidebarOpen(false);
  });

  const openNewListDialog = (groupId?: string) => {
    setSelectedList(null);
    setCreationGroupId(groupId);
    setListDialogOpen(true);
  };

  const openNewGroupDialog = () => {
    setEditingGroup(null);
    setGroupDialogOpen(true);
  };

  const openChoiceDialog = (groupId?: string) => {
    setCreationGroupId(groupId);
    setChoiceDialogOpen(true);
  };

  const openEditListDialog = (list: ListWithMeta) => {
    setSelectedList(list);
    setListDialogOpen(true);
  };

  const openShareListDialog = (list: ListWithMeta) => {
    setSelectedList(list);
    setShareDialogOpen(true);
  };

  const openEditGroupDialog = (group: ListGroup) => {
    setEditingGroup(group);
    setGroupDialogOpen(true);
  };

  return {
    listDialogOpen,
    setListDialogOpen,
    creationGroupId,
    setCreationGroupId,
    shareDialogOpen,
    setShareDialogOpen,
    selectedList,
    setSelectedList,
    isSidebarOpen,
    setIsSidebarOpen,
    choiceDialogOpen,
    setChoiceDialogOpen,
    groupDialogOpen,
    setGroupDialogOpen,
    editingGroup,
    setEditingGroup,
    shortcutsOpen,
    setShortcutsOpen,
    openNewListDialog,
    openNewGroupDialog,
    openChoiceDialog,
    openEditListDialog,
    openShareListDialog,
    openEditGroupDialog,
  };
}
